// "Fecha de hoy" del sistema, siempre calculada en America/Mexico_City —
// nunca con new Date().toISOString() (que refleja UTC) ni con la hora local
// implícita del navegador. Ver diagnóstico del bug de zona horaria
// (2026-09-24): de 18:00 a 23:59 hora CDMX, UTC ya es el día siguiente, así
// que cualquier "hoy" calculado en UTC se adelanta un día durante esa
// ventana. Mismo helper que backend/utils/fechaMexico.js.
//
// `now` es inyectable (default: instante actual) para poder probar la
// frontera de las 6pm CDMX con instantes UTC exactos.
const TIMEZONE = 'America/Mexico_City';

export function hoyISO(now = new Date()) {
  // en-CA formatea como YYYY-MM-DD directo.
  return now.toLocaleDateString('en-CA', { timeZone: TIMEZONE });
}

export function primerDiaMesISO(now = new Date()) {
  const ym = now.toLocaleDateString('en-CA', { timeZone: TIMEZONE, year: 'numeric', month: '2-digit' });
  return `${ym}-01`;
}
